import PropTypes from "prop-types";

const Visible = ({ isVisible, children }) => {
    return isVisible ? children : null;
};

Visible.propTypes = {
    isVisible: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        .isRequired,
};

export default Visible;
